import { Box, Grid } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import axios from 'axios'
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { authContext } from '../../context/AuthContext'
import Loading from '../helper/Loading'
import PageHeader from '../helper/PageHeader'
import { SearchBarFirstLastRequired } from '../helper/SearchBars'
import SimpleTable from '../helper/SimpleTable'
import styles from '../styles'

// function updatePermissions(permArray, toUpdateNum, updateType) {
//     let original = {
//         isClassroomTrainingAdmin: permArray.includes('4') ? 1 : 0,
//         isClassroomTrainingManager: permArray.includes('402') ? 1 : 0,
//         isInstructorAdministrator: permArray.includes('8') ? 1 : 0,
//         isOnlineTrainingAdmin: permArray.includes('3') ? 1 : 0,
//         isOnlineTrainingEditor: permArray.includes('301') ? 1 : 0,
//         isProgramCoordinator: permArray.includes('6') ? 1 : 0,
//         isRoleAdmin: permArray.includes('0') ? 1 : 0,
//         isTrainingCouponAdmin: permArray.includes('7') ? 1 : 0,
//         isUserAdmin: permArray.includes('1') ? 1 : 0,
//     }
//     console.log("Before update", original)
//     original[toUpdateNum] = (updateType === "add") ? 1 : 0
//     return original
// }

const numToPermMap = {
    '0': "isRoleAdmin",
    '1': "isUserAdmin",
    '301': "isOnlineTrainingEditor",
    '4': "isClassroomTrainingAdmin",
    '402': "isClassroomTrainingManager",
    '6': "isProgramCoordinator",
    '7': "isTrainingCouponAdmin",
    '8': "isInstructorAdministrator",

}

export const permissionsMap = [
    { num: '0', value: "RoleAdmin", title: "Manage User Permissions", detail: "Manage user permissions" },
    { num: '1', value: "UserAdmin", title: "Manage Users", detail: "Manage user profiles, reset user's passwords, view profile change logs." },
    { num: '3', value: "OnlineTrainingAdmin", title: "Manage online training records", detail: "View all online training reports - student module progress and tests, purchases and coupon reports.  Disregard/delete tests and enter test scores from paper tests (Note: new system should not allow deleting tests but should allow transferring them to different account)" },
    { num: '301', value: "OnlineTrainingEditor", title: "Manage online training settings", detail: "Manage online training courses general information / settings" },
    { num: '4', value: "ClassroomTrainingAdmin", title: "Manage Classroom Option Lists", detail: "Manage the option lists used in classroom training including location template, contact template, regions, organization, category."},
    { num: '402', value: "ClassroomTrainingManager", title: "Manage classes", detail: "Edit classes created by other users" },
    { num: '6', value: "ProgramCoordinator", title: "Approve classes", detail: "Approve (publish) classes added late or with higher cost" },
    { num: '7', value: "TrainingCouponAdmin", title: "Manage user purchases", detail: "Create free coupons [new system - add free credit & also remove credit or training after or account transfer]" }, //obsolete
    { num: '8', value: "InstructorAdministrator", title: "Manage instructors", detail: "Add/Edit Instructors [+ for new system Add/Edit Training provider organizations (not well defined yet)]" },
]

const tableCells = [
    { id: 'username', label: 'Username', centered: false },
    { id: 'first_name', label: 'First Name', centered: false },
    { id: 'last_name', label: 'Last Name', centered: false },
    { id: 'email', label: 'Email', centered: false },

];

const tableCells2 = [
    { id: 'username', label: 'Username', centered: false },
    { id: 'firstName', label: 'First Name', centered: false },
    { id: 'lastName', label: 'Last Name', centered: false },
];

const AdminRolesManage = props => {
    const { classes } = props
    const history = useHistory()
    const user = useContext(authContext)

    const [loadingCurrent, setLoadingCurrent] = useState(true)
    const [currentUsers, setCurrentUsers] = useState(null)

    const [loadingSearch, setLoadingSearch] = useState(false)
    const [searchData, setSearchData] = useState(null)
    const [originalLength, setOriginalLength] = useState(-1)

    const [ usernamesList, setUsernamesList ] = useState([])

    const mounted = useRef(true)

    const role = permissionsMap.find((val) => val.value === props.match.params.role)

    const getCurrentUsers = useCallback(async () => {
        setLoadingCurrent(true)
        const res = await axios.get("/api/user/permissions/search", {
            params: {
                permissionType: role ? props.match.params.role : undefined
            }
        })

        if (mounted.current) {
            //const data = res.data.users
            console.log(res.data)
            let current = res.data.users
            let tempUsernameList = []
            current.map((curr)=>{
                tempUsernameList.push( curr['username'] )
            })
            setUsernamesList( tempUsernameList )
            setCurrentUsers(res.data.users)
            setLoadingCurrent(false)
        }

    }, [role, props.match.params.role])
    useEffect(() => {
        getCurrentUsers()
        // on unmount
        return () => {
            console.log("UNMOUNTED")
            return mounted.current = false
        }
    }, [getCurrentUsers])






    const onSearch = async (search) => {
        setLoadingSearch(true)
        const res = await axios.get("/api/user/search", {
            headers: {
                Authorization: user.accessToken
            },

            params: {
                username: null,
                firstName: search.firstName === '' ? null : search.firstName,
                lastName: search.lastName === '' ? null : search.lastName,
            }
        })

        if (mounted.current) {
            const data = res.data.users.slice(0, 100).map(user => ({
                id: user.username,
                username: user.username,
                firstName: user.first_name,
                lastName: user.last_name
            }))
            console.log(res.data.users)
            disableAddedUsers( data, usernamesList )
            
            setOriginalLength(res.data.users.length)
            
            setLoadingSearch(false)
        }

    }

    const disableAddedUsers = ( searchedUserData, addedUserList  ) => {
        console.log('searcheduserData', searchedUserData)
        console.log('addedUserList', addedUserList)
        searchedUserData.map((d)=>{
            d.actionsDisabled = {
                add : addedUserList.includes(d.username) ? true: false
            }
        })
        setSearchData(searchedUserData)
    }

    const onAdd = async user => {
        console.log("ADD", user)
        const res = await axios.get("/api/user/permissions/" + user)
        let perms = res.data.permissions
        console.log("Before add", perms,res.data)
        if (res.data.permissions[numToPermMap[role.num]] === 0) { // if the perm is already 1, then do nothing
            perms[numToPermMap[role.num]] = 1
            console.log("After add", perms)
            updatePerm(user, perms)
            let tempUsernameList = usernamesList
            tempUsernameList.push(user)
            disableAddedUsers( searchData, tempUsernameList )
        }
    }

    const onRemove = user => {
        console.log("REMOVE", user)
        let perms = currentUsers.find((u) => u.username === user)
        perms.username=undefined
        perms.first_name=undefined
        perms.last_name=undefined
        perms.email=undefined
        console.log("Before remove", perms)
        perms[numToPermMap[role.num]] = 0
        updatePerm(user, perms)
        let index = usernamesList.indexOf(user)
        let newUsernameList = usernamesList.splice(index, 1)
        console.log('username list', newUsernameList)
        disableAddedUsers( searchData, usernamesList )
        // setUsernamesList(newUsernameList)

    }

    const updatePerm = async (username, perms) => {
        let data = {
            byUsername: user.user.username,
            permissions: perms
        }

        const res = await axios.post("/api/user/permissions/" + username, data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: user.accessToken
            }
        })
        console.log(res)
        if (res.status === 200){
            getCurrentUsers()
        }

    }

    const actionButtons = [
        { icon: "remove", label: "Remove Permission", action: onRemove, delete: false },
    ];

    const actionButtons2 = [
        { icon: "add", label: "Add Permission", action: onAdd, delete: false },
    ];

    return (
        <>
            {role ?
                <>
                    <PageHeader
                        title={role.title}
                        cancel={history.goBack}
                    />
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={6}>
                            <h1>Current Users</h1>
                            <br />
                            {loadingCurrent ? <Loading /> :
                            <>
                                <SimpleTable
                                    data={currentUsers}
                                    cellKey={"username"}
                                    tableCells={tableCells}
                                    actionButtons={actionButtons}
                                    actions={true}
                                />
                                <br />
                                <br />
                                </>
                            }
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <h1>Add Users</h1>
                            <br />
                            <SearchBarFirstLastRequired classes={classes} onSearch={onSearch} />

                            <br /><br />

                            {loadingSearch ? <Loading /> : // if loading display message
                                searchData === null ?
                                    null : // if there is no data display nothing
                                    searchData.length === 0 // if there is data but it is empty
                                        ?
                                        <Box display="flex" mt={4} justifyContent="center">
                                            <h1>No Data</h1>
                                        </Box>
                                        :
                                        <>
                                            {originalLength > 100 && <p>{`Found too many results (${originalLength}) limiting results to 100`}</p>}
                                            <SimpleTable
                                                data={searchData}
                                                cellKey={"username"}
                                                tableCells={tableCells2}
                                                actionButtons={actionButtons2}
                                                actions={true}
                                            />
                                        </>
                            }
                        </Grid>
                    </Grid>



                </>
                : <PageHeader
                    title="Invalid ID"
                    cancel={history.goBack}
                />}

        </>
    )
}

export default withStyles(styles, { withTheme: true })(AdminRolesManage)